import { createSlice } from '@reduxjs/toolkit'

const appNotificationsSlice = createSlice({
  name: 'appNotifications',
  initialState: {
    registerBeneficiariesAlert: {
      type: '', // error || info
      message: '',
    },
  },
  reducers: {
    setRegisterBeneficiariesAlert: (state, action) => {
      const { type, message } = action.payload;
      state.registerBeneficiariesAlert.type = type;
      state.registerBeneficiariesAlert.message = message;
    },
    resetRegisterBeneficiariesAlert: (state) => {
      state.registerBeneficiariesAlert.type = '';
      state.registerBeneficiariesAlert.message = '';
    },
  },
})

export const {
  setRegisterBeneficiariesAlert,
  resetRegisterBeneficiariesAlert,
} = appNotificationsSlice.actions;

export default appNotificationsSlice.reducer;